/**
 * Module for creating a transformation action as part of the action item creation wizard
 */
define(["marionette", "messaging/messenger", "./transformationActionItemView"], function (
  Marionette,
  Messenger,
  TransformationActionItemView,
) {
  var TransformationActionItemModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "transformationActionItem";
      this.region = options.region;
      this.isComplex = false;
    },
    show: function (transformationActionItem) {
      this.actionItem = transformationActionItem;
      transformationActionItem.variables = Messenger.reqres.request("action:variables");

      this.view = new TransformationActionItemView.transformationActionItemView({
        model: transformationActionItem,
      });

      this.view.on(
        "toggle:complex:expression",
        function () {
          if (this.isComplex == false) {
            this.view.showComplexExpression();
            this.isComplex = true;
          } else {
            this.view.hideComplexExpression();
            this.isComplex = false;
          }
        },
        this,
      );

      transformationActionItem.on(
        "invalid",
        function (model, error) {
          this.view.clearErrors();
          if ("conversationVariableId" in error) {
            this.view.variableError(error["conversationVariableId"]);
          }
          if ("expression" in error) {
            if (this.isComplex) {
              this.view.secondExpressionError(error["expression"]);
            } else {
              this.view.expressionError(error["expression"]);
            }
          }
        },
        this,
      );

      this.showRegion(this.view);

      if (this.actionItem.getOperator() === "") {
        this.view.hideComplexExpression();
      } else {
        this.view.showComplexExpression();
        this.isComplex = true;
      }
    },
    getActionItem: function () {
      return this.actionItem;
    },
    isValid: function (callback, context) {
      var variables = Messenger.reqres.request("action:variables");
      var expression;
      var secondExpression = "";
      var operator = "";

      expression = this.view.getExpression().replace(/"/g, "");

      if (this.isComplex) {
        operator = this.view.getOperator();
        secondExpression = this.view.getSecondExpression().replace(/"/g, "");
        this.actionItem.setSecondExpression(secondExpression, variables);
      }
      this.actionItem.setFirstExpression(expression, variables);
      this.actionItem.setComplexExpression(this.isComplex);

      //grab the entered conversation variable and expression, convert to IDs if necessary, then validate
      this.actionItem.setConversationVariableId(this.view.getConversationVariable(), variables);
      this.actionItem.setExpression(expression, secondExpression, operator, variables);

      if (this.actionItem.isValid()) {
        callback.apply(context);
      }
    },
  });

  return TransformationActionItemModule;
});
